import React from 'react';
import GivePage from './GivePage';

const BODY = `Registered parishioners receive a set of numbered offering envelopes for each Sunday of the year. Envelopes make it easy to make your weekly gift during Mass and to receive a year-end tax receipt for your recorded contributions.

If you'd like to be added to the envelope list, please register as a parishioner or contact the parish office. Envelope packages are available at the entrance of each church for pick-up.`;

const GiveEnvelopes = () => (
  <GivePage
    slug="give-envelopes"
    title="Weekly Envelopes"
    contentKey="give_envelopes_body"
    defaultBody={BODY}
  />
);

export default GiveEnvelopes;
